import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { AdvertisementPlaylistStateModel } from 'models/setting/advertisement/advertisement-playlist.model';
import {
  activeAdvertisementPlaylistAction,
  createAdvertisementPlaylistAction,
  deleteAdvertisementPlaylistAction,
  getAdvertisementPlaylistAction,
  inactiveAdvertisementPlaylistAction,
  listAdvertisementPlaylistAction,
  updateAdvertisementPlaylistAction,
} from './advertisement-playlist.action';

const initialState: AdvertisementPlaylistStateModel = {
  advertisementPlaylistListData: null,
  advertisementPlaylistDetail: null,
  triggerSaveAdvertisementPlaylist: null,

  loadingList: false,
};

export const advertisementPlaylistSlice = createSlice({
  name: 'advertisement-playlist',
  initialState,
  reducers: {
    setAdvertisementPlaylistStateAction: (
      state,
      action: PayloadAction<Partial<AdvertisementPlaylistStateModel>>,
    ) =>
      ({
        ...state,
        ...action?.payload,
      } as AdvertisementPlaylistStateModel),
    resetAdvertisementPlaylistStateAction: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdvertisementPlaylistAction.pending, (state) => ({
        ...state,
        advertisementPlaylistDetail: null,
        loadingDetail: true,
      }))
      .addCase(
        getAdvertisementPlaylistAction.fulfilled,
        (state, { payload }) => ({
          ...state,
          advertisementPlaylistDetail: payload?.data || null,
          loadingDetail: false,
        }),
      )
      .addCase(getAdvertisementPlaylistAction.rejected, (state) => ({
        ...state,
        advertisementPlaylistDetail: null,
        loadingDetail: false,
      }))
      .addCase(listAdvertisementPlaylistAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(
        listAdvertisementPlaylistAction.fulfilled,
        (state, { payload }) => ({
          ...state,
          loadingList: false,
          advertisementPlaylistListData: {
            items: payload?.data?.items || [],
            totalItems: payload?.data?.totalItems || 0,
            totalPages: payload?.data?.totalPages || 0,
          },
        }),
      )
      .addCase(listAdvertisementPlaylistAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(createAdvertisementPlaylistAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisementPlaylist: { id: uuidv4() },
      }))
      .addCase(updateAdvertisementPlaylistAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisementPlaylist: { id: uuidv4() },
      }))

      .addCase(deleteAdvertisementPlaylistAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(deleteAdvertisementPlaylistAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisementPlaylist: { id: uuidv4() },
      }))
      .addCase(deleteAdvertisementPlaylistAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(activeAdvertisementPlaylistAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisementPlaylist: { id: uuidv4() },
        loadingList: false,
      }))
      .addCase(inactiveAdvertisementPlaylistAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisementPlaylist: { id: uuidv4() },
        loadingList: false,
      }));
  },
});

export const {
  setAdvertisementPlaylistStateAction,
  resetAdvertisementPlaylistStateAction,
} = advertisementPlaylistSlice.actions;

export default advertisementPlaylistSlice.reducer;
